<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <!-- formulario -->
    <v-row justify="center">
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2" :loading="formLoading">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Registrar Categoria
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col cols="12" sm="10" lg="8">
                <v-form ref="form" v-model="form">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Categoria*"
                    maxlength="100"
                    counter
                    v-model="categoria"
                    :rules="categoriaReglas"
                  >
                  </v-text-field>

                  <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    accept="image/png, image/jpeg"
                    label="Logotipo"
                    truncate-length="50"
                    counter
                    show-size
                    v-model="logotipo"
                    :rules="logotipoReglas"
                  >
                  </v-file-input>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model="descripcion"
                  >
                  </v-textarea>

                  <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    accept="application/pdf"
                    label="Lineamientos"
                    truncate-length="100"
                    counter
                    show-size
                    v-model="documentoLineamientos"
                    :rules="documentoLineamientosReglas"
                  >
                  </v-file-input>

                  <v-select
                    outlined
                    multiple
                    small-chips
                    label="Aliado"
                    :items="aliados"
                    :rules="aliadoReglas"
                    item-value="id"
                    item-text="aliado"
                    v-model="aliado"
                  >
                  </v-select>
                  <v-btn
                    large
                    block
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="registrar"
                  >
                    Registrar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    form: true,
    formLoading: false,

    categoria: "",
    categoriaReglas: [(v) => !!v || "Escriba una categoria"],

    logotipo: null,
    logotipoReglas: [
      (v) =>
        !v ||
        v.size < 2000000 ||
        "El tamaño del logotipo debe ser menor que 2 MB",
    ],

    descripcion: null,

    documentoLineamientos: null,
    documentoLineamientosReglas: [
      (v) =>
        !v ||
        v.size < 5000000 ||
        "El tamaño del documento debe ser menor que 5 MB",
    ],

    aliado: [],
    aliadoReglas: [(v) => !!v || "Seleccione minimo un aliado"],
  }),

  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch("gestionarAliadosCampesena");
  },

  computed: {
    aliados() {
      return this.$store.getters.obtenerAliadosCampesena;
    },
  },

  methods: {
    registrar() {
      if (this.$refs.form.validate()) {
        const categoria = new FormData();
        categoria.set("categoria", this.categoria.toLowerCase());
        categoria.set("logotipo", this.logotipo);
        categoria.set("descripcion", this.descripcion);
        categoria.set("documento_lineamientos", this.documentoLineamientos);
        categoria.set("aliados", this.aliado);

        this.formLoading = true;
        this.$store
          .dispatch("registrarCategoriaCampesena", categoria)
          .then((response) => {
            if (response.status == "success") {
              this.$refs.form.reset();
              this.formLoading = false;

              let message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
                this.$router.replace({ name: "campesena-categoria-gestionar" });
              }, 2000);
            } else {
              this.formLoading = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";
              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>
